import { render, staticRenderFns } from "./extendTool.vue?vue&type=template&id=8ba47cf6&scoped=true&"
import script from "./extendTool.vue?vue&type=script&lang=js&"
export * from "./extendTool.vue?vue&type=script&lang=js&"
import style0 from "./extendTool.vue?vue&type=style&index=0&id=8ba47cf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba47cf6",
  null
  
)

export default component.exports